import React from 'react';

const MyPageIconButton = ({ onClick, iconClassName, buttonTxt }) => {
  return (
    <button type='button' className='button-default toggle-content-button' onClick={onClick}>
      <span className='toggle-icon-group'>
        <i className={`icon ${iconClassName}`} />
      </span>
      {buttonTxt}
    </button>
  );
};

export default MyPageIconButton;
